import { onFind } from "@elements/init-modules-in-scope";
import { RayEditor } from "../libs/ray-editor/ray-editor.js";
export function init(){
    onFind('.js-ray-editor', (element) => {
        // Get the element's ID or generate a unique one if it doesn't have one
        let editorId = element.id;
        if (!editorId) {
            editorId = 'ray-editor-' + Math.random().toString(36).substring(2, 9);
            element.id = editorId;
        }

        // Create a container div for the RayEditor
        const container = document.createElement('div');
        container.id = `${editorId}-container`;
        container.className = 'ray-editor-container';
        // Place the container before the original element and move the element inside it
        element.parentNode?.insertBefore(container, element);
        container.appendChild(element);
        const initEditor = () => {
            // @ts-ignore
            const editor = new RayEditor(container.id, {
                bold: true,
                italic: true,
                underline: true,
                redo: true,
                undo: true,
                orderedList: true,
                unorderedList: true,
                link: false,
                undo_redo: true,
                initStyles: false,
                stylesheetUrl: "",
                hideWatermark: false,
                toolbarType: "default",
                overflowMenu: false,
                showSource: false,
                removeFormat: false,
            });
            // Accessibility and ARIA wiring for the contenteditable surface (Option A)
            try {
                const textarea = element;
                const editorEl = editor.editorArea; // contenteditable surface
                // Ensure label has an id and connect it via aria-labelledby
                const label = document.querySelector(`label[for="${editorId}"]`) | null;
                if (label && !label.id) {
                    label.id = `${editorId}-label`;
                }
                // Make contenteditable act like a proper textbox for AT
                if (!editorEl.id) editorEl.id = `${editorId}-editor`;
                editorEl.setAttribute('role', 'textbox');
                editorEl.setAttribute('aria-multiline', 'true');
                if (label?.id) editorEl.setAttribute('aria-labelledby', label.id);
                const describedBy = textarea.getAttribute('aria-describedby');
                if (describedBy) editorEl.setAttribute('aria-describedby', describedBy);
                if (!editorEl.hasAttribute('tabindex')) editorEl.setAttribute('tabindex', '0');
                // Keep original textarea for form submission but remove it from the AT tree
                textarea.setAttribute('aria-hidden', 'true');
                textarea.setAttribute('tabindex', '-1');
                // Visually hide using CSS utility class
                textarea.classList.add('ray-editor__hidden-input');
                // Clicking label should focus the editor surface
                if (label) {
                    label.addEventListener('click', (ev) => {
                        ev.preventDefault();
                        editorEl.focus();
                    });
                }
            } catch (e) {
                console.error('Error setting up accessibility:', e);
                // no-op if structure differs
            }
            // Set initial content if available
            if (element.innerHTML) {
                try {
                    // @ts-ignore - RayEditor methods
                    // Use innerHTML directly but ensure it's properly decoded
                    function decodeHtmlEntities(str) {
                        const textarea = document.createElement('textarea');
                        textarea.innerHTML = str;
                        return textarea.value;
                    }
                    const rawHtml = element.innerHTML.trim();
                    const decodedHtml = decodeHtmlEntities(rawHtml);
                    editor.setRayEditorContent(decodedHtml);
                } catch (error) {
                    console.error('Error setting RayEditor content:', error);
                }
            }
            // Update the hidden textarea on content change for form submission
            // @ts-ignore - RayEditor events
            editor.editorArea.addEventListener('input', function() {
                // @ts-ignore - RayEditor methods
                element.value = editor.getRayEditorContent();
                // Fire a change event on the textarea whenever its value is updated
                const event = new Event('change', { bubbles: true });
                element.dispatchEvent(event);
            });
        };
        initEditor();
    });
}
